import type { OrderStatus } from '../types';

const LABELS: Record<OrderStatus, string> = {
  awaiting_payment: 'Czeka na płatność',
  paid: 'Opłacone',
  shipped: 'Wysłane',
  merged: 'Połączone',
  pickup: 'Odbiór',
  cancelled: 'Anulowane',
};

/** Falls back to the raw value so an unmapped backend status stays diagnosable. */
export function statusLabel(status: string): string {
  return LABELS[status as OrderStatus] ?? status;
}

export function StatusPill({ status }: { status: OrderStatus }) {
  return <span className={`pill ${status}`}>● {statusLabel(status)}</span>;
}
